import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import { FragmentMessages } from "../../common/fragment-messages";

export default class Lateral extends Fragment {
    constructor(lateralTo, receivedAt) {
        super();

        this.lateralTo = lateralTo;
        this.receivedAt = receivedAt;

        this.requiredData = [
            {
                name: "lateralTo",
                type: FragmentDataType.Player,
                displayName: "Lateral To",
                title: (team) => `Lateral To: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "receivedAt",
                type: FragmentDataType.FieldPosition,
                displayName: "Received At",
                title: "Received At",
                subtitle: `Enter where the ball was recovered. ${FragmentMessages.FB_TEAM_FIELD_POSITION}`,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }

    getFieldPosition() {
        return this.receivedAt;
    }

    updateSummaryContext(summaryContext) {
        summaryContext.fieldPosition = this.receivedAt;
        summaryContext.playerInPossession = this.lateralTo;
    }

    getFragmentTeamId() {
        return this.lateralTo?.teamId;
    }

    getPlayers() {
        return [this.lateralTo];
    }

    summarize(summaryContext, stringifier) {
        const message = `lateral to ${stringifier.firstInitial(
            this.lateralTo
        )} for ${stringifier.gain(
            summaryContext,
            summaryContext.fieldPosition,
            this.receivedAt
        )}`;

        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            lateralTo: playerReducer(this.lateralTo)
        };
    }
}
